import { BannerThemeOption } from '@helpers/brand';
import { imageUrl } from '@helpers/image';
import { withBaseProps } from '@hoc/withBaseProps';
import SvgSpeechBubble from '@img/icons/speech-bubble.svg';
import { ButtonType } from '@stories/Components/Buttons/Button/ButtonType';
import CallButton from '@stories/Components/Buttons/CallButton/CallButton';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import TrustpilotBlock from '@stories/Components/Misc/TrustpilotBlock/TrustpilotBlock';
import React from 'react';
import S from '../InnerHeroBanner.styles';
const VariantImage = (props) => {
    const contactCtaTheme = props.theme === BannerThemeOption.DarkCoral || props.theme === BannerThemeOption.GreenDark
        ? 'light'
        : 'dark';
    return (React.createElement(React.Fragment, null,
        React.createElement(S.ContentColumn, null,
            React.createElement(S.Title, null, props.title),
            props.titleSupportingText && (React.createElement(S.TitleSupportingText, null, props.titleSupportingText)),
            props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
            React.createElement(S.RowContainer, null,
                props.cta && (React.createElement(LinkButton, { href: props.cta.url, target: props.cta.target ?? '_self', buttonType: ButtonType.Default, icon: React.createElement(SvgSpeechBubble, null) }, props.cta.text)),
                props.contactCta && (React.createElement(S.ContactWrapper, { "data-cta-theme": contactCtaTheme },
                    React.createElement(CallButton, { ...props.contactCta })))),
            props.trustpilot && React.createElement(TrustpilotBlock, { ...props.trustpilot })),
        React.createElement(S.ImageColumn, null, props.image && (React.createElement(S.ImageWrapper, null,
            React.createElement(S.Image, { alt: props.image.altText, loading: "eager", role: props.image.altText ? undefined : 'presentation', sizes: "100vw", src: imageUrl(props.image, { width: 480, heightratio: 588 / 1024 }), srcSet: [
                    `${imageUrl(props.image, { width: 320, heightratio: 588 / 1024 })} 320w`,
                    `${imageUrl(props.image, { width: 480, heightratio: 588 / 1024 })} 480w`,
                    `${imageUrl(props.image, { width: 767, heightratio: 588 / 1024 })} 767w`,
                    `${imageUrl(props.image, { width: 496, heightratio: 429 / 944 })} 1024w`,
                    `${imageUrl(props.image, { width: 704, heightratio: 429 / 944 })} 1440w`,
                    `${imageUrl(props.image, { width: 944, heightratio: 429 / 944 })} 1920w`,
                ].join(','), width: "944", height: "429" }))))));
};
export default withBaseProps(VariantImage);
